import React, { useEffect } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logoutAuth } from "../features/setting/userSlice";

const PrivateRoutes = () => {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.user);
  const isAuthenticated = data?.token;
  
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "logout") {
        dispatch(logoutAuth());
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [dispatch]);

  return isAuthenticated ? <Outlet /> : <Navigate to="/" />;
};

export default PrivateRoutes;
